var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-bike-map"},[_c('GoogleMaps',{attrs:{"dialogName":'ViewBike',"lastRideCoordinates":this.lastRideCoordinates,"trackerCoordinates":this.trackerCoordinates,"bikeCoordinates":_vm.bike},on:{"markerDragEnd":_vm.handleMarkerDragEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }